import m from 'moment';

export default function getDate(date) {
	return m(date, 'YYYYMMDD');
}